import { useEffect, useState } from "react";
import CustomNavItem from "../../../Components/Components/CustomNavItem";
import ProductDocumentation from "../../../Components/ProductPage/ProductDocumentation";

const ProductDetails = ({ product }) => {
    const [tabs, setTabs] = useState(['Dokumentacja'])
    const [activeTab, setActiveTab] = useState('Dokumentacja')

    useEffect(() => {
        if (product.description && product.description.trim() != '') {
            setTabs(prev => {
                if (prev.includes('Opis produktu')) {
                    return prev
                }
                return ['Opis produktu', ...prev]
            })
            setActiveTab('Opis produktu')
        }
        if (product.productInformations && product.productInformations.length > 0) {
            setTabs(prev => {
                if (prev.includes('Cechy produktu')) {
                    return prev
                }
                return ['Cechy produktu', ...prev]
            })
            setActiveTab('Cechy produktu')
        }
    }, [product])

    const generateContent = () => {
        switch (activeTab) {
            case 'Opis produktu':
                return <DetailsTab description={product.description} />
            case 'Cechy produktu':
                return <ProductInformation
                    product={product}
                />
            case 'Dokumentacja':
                return <ProductDocumentation
                    index={product.index}
                />
        }
    }

    return (
        <div style={{ height: '70vh' }}>
            <div className="mb-3">
                <CustomNavItem
                    items={tabs}
                    defaultItem={tabs[0]}
                    onClick={(item) => setActiveTab(item)}
                />
            </div>
            <div className="main-container-holder" style={{ width: '100%', minHeight: '90%', marginTop: '-10px' }}>
                {generateContent()}
            </div>
        </div>
    )
}

const DetailsTab = ({ description }) => {
    return (
        <div>
            {/* <p style={{ fontSize: '20px' }}>{description}</p> */}
            <div className="content" dangerouslySetInnerHTML={{ __html: description }}></div>
        </div>
    )
}
const ProductInformation = ({ product }) => {
    return (
        <div>
            <div className="container">
                <div className="row">
                    <div className="col-md-6">
                        {product.productInformations && product.productInformations.slice(0, Math.ceil(product.productInformations.length / 2)).map((item, index) => (
                            // <div key={index} className="d-flex justify-content-between">
                            //     <p>{item.name}:</p>
                            //     <p><strong>{item.value}</strong></p>
                            // </div>
                            <div className="row">
                                <div className="col-6 text-start">
                                    <p>{item.name}:</p>
                                </div>
                                <div className="col-6 text-end">
                                    <p><strong>{item.value}</strong></p>
                                </div>
                            </div>
                        ))}
                    </div>
                    <div className="col-md-6">
                        {product.productInformations && product.productInformations.slice(Math.ceil(product.productInformations.length / 2)).map((item, index) => (
                            // <div key={index} className="d-flex justify-content-between">
                            //     <p>{item.name}:</p>
                            //     <p><strong>{item.value}</strong></p>
                            // </div>
                            <div className="row">
                                <div className="col-6 text-start">
                                    <p>{item.name}:</p>
                                </div>
                                <div className="col-6 text-end">
                                    <p><strong>{item.value}</strong></p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ProductDetails